import { getAPIUrl } from '../global';
import { GetApi,PostApi, PostcandidateApi } from '../headerCandidateIntercepter';
import { Get } from '../headerIntercepter';

export const otpVarify = (data) => {
  const url = getAPIUrl('candidate.login');
  return PostApi(url, data, false);
};

export const craeteCandidate = (data) => {
  const url = getAPIUrl('candidate.create');
  return PostcandidateApi(url, data, true);
};
export const getCandidateByEmail = (data) => {
  const url = getAPIUrl('candidate.candidatebyemail');
  return PostApi(url, data, true);
};

export const gettestDetail = () => {
  const url = getAPIUrl('candidate.test.details');
  return GetApi(url, true, {});
}

export const getTest = () => {
  const url = getAPIUrl('candidate.test.self');
  return GetApi(url, true, {});
}

export const submitTest = (data) => {
  const url = getAPIUrl('candidate.test.submit');
  return PostApi(url, data, true);
}

export const getCandidate = (params={}) => {
  const url = getAPIUrl('organization.candidate',params);
  return Get(url, true, {});
}
export const getCandidatebyId = (params={}) => {
  const url = getAPIUrl('organization.candidatebyId',params);
  return Get(url, true, {});
}


export const getCandidateTest = (params={}) => {
  const url = getAPIUrl('candidate.getCandidateTest',params);
  return Get(url, true, {});
}